import { Loader2, Check, CircleDashed, AlertCircle } from "lucide-react";

/**
 * Small pill that reflects the state returned by `useAutoSave`.
 * Meant to live in a DialogFooter next to the primary action button.
 */
export function AutoSaveStatus({ status, lastSavedAt, className = "" }) {
  let icon = null;
  let text = "";
  let color = "text-muted-foreground";

  if (status === "saving") {
    icon = <Loader2 className="h-3 w-3 animate-spin" />;
    text = "Saving…";
  } else if (status === "saved") {
    icon = <Check className="h-3 w-3" />;
    text = lastSavedAt
      ? `Saved ${lastSavedAt.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}`
      : "Saved";
    color = "text-green-600";
  } else if (status === "dirty") {
    icon = <CircleDashed className="h-3 w-3" />;
    text = "Unsaved changes";
    color = "text-amber-600";
  } else if (status === "error") {
    icon = <AlertCircle className="h-3 w-3" />;
    text = "Save failed";
    color = "text-red-600";
  } else {
    return null;
  }

  return (
    <span
      className={`inline-flex items-center gap-1 text-xs ${color} ${className}`}
      data-testid={`autosave-status-${status}`}
    >
      {icon}
      {text}
    </span>
  );
}
